const hasHttpProtocol = (url: string): boolean => {
  const lowerUrl = url.toLowerCase();

  return lowerUrl.startsWith('http://') || lowerUrl.startsWith('https://');
};

const hasProtocol = (url: string, protocolPrefix: string): boolean => {
  return url.toLowerCase().startsWith(protocolPrefix);
};

const prefixUrlWithProtocol = (url: string, protocol = 'https://') => {
  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.protocol === 'mailto:' || parsedUrl.protocol === 'tel:') {
      return url;
    }

    if (import.meta.env.PROD && parsedUrl.protocol === 'http:') {
      parsedUrl.protocol = 'https:';
      return parsedUrl.toString();
    }

    if (parsedUrl.protocol.startsWith('http')) {
      return url;
    }

    return `${protocol}${url}`;
  } catch {
    // If URL parsing fails, it means there's no protocol
    if (!hasHttpProtocol(url) && !hasProtocol(url, 'mailto:') && !hasProtocol(url, 'tel:')) {
      return `${protocol}${url}`;
    }
    return url;
  }
};

export { prefixUrlWithProtocol };
